import { useFeatureFlagConfig, useUpdateFeatureFlagConfig } from "@/entities/config";
import { Separated, Switch } from "@/shared/components";

export function FeatureFlags() {
    const { data } = useFeatureFlagConfig();
    const updateMutation = useUpdateFeatureFlagConfig();

    if (!data) {
        return <div>Loading...</div>;
    }

    function toggleFlag(flagName: string) {
        const newFlags = {
            ...data,
            [flagName]: !data?.[flagName],
        };
        updateMutation.mutate(newFlags);
    }

    return (
        <div className="grid gap-2 p-2">
            <h3 className="text-l text-content-emphasis">Toggle Feature Flags</h3>
            <ol className="bg-elevated-sunken rounded-m">
                <Separated>
                    {Object.entries(data).map(([flagName, isEnabled]) => (
                        <li key={flagName} className="flex items-center justify-between px-3 py-1">
                            <span>{flagName}</span>
                            <Switch
                                className="justify-end"
                                checked={isEnabled}
                                onCheckedChange={() => toggleFlag(flagName)}
                                disabled={updateMutation.isPending}
                            />
                        </li>
                    ))}
                </Separated>
            </ol>
        </div>
    );
}
